import { useAuthContext } from "src/auth/AuthContext";
import FundsForm from "./FundsForm";
import { fundService } from "src/service/FundService";
import { useParams } from "react-router-dom";

const FundsEdit = () => {
    const { user } = useAuthContext();
    const { id } = useParams();
    return <FundsForm
        fundId={parseInt(id)}
        organizationId={user.data.organizationId}
        onSubmit={(entry) => fundService.update(entry)}
        header='Fonds Bearbeiten'
    />;
};

export default FundsEdit;
